<template>
  <a-card class="auth__card" title="Восстановление  пароля">
    <a-form>
      <a-form-item label="Ваш email">
        <a-input
          v-model="params.email"
          type="email"
          placeholder="user@mail.com"
        ></a-input>
      </a-form-item>
      <a-form-item>
        <a-button
          @click.prevent="reset"
          :loading="isLoading"
          class="button"
          block
          type="primary"
          html-type="submit"
          >Восстановить пароль</a-button
        >
      </a-form-item>
      <p>
        <router-link to="/auth/login">Назад</router-link>
      </p>
    </a-form>
  </a-card>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      params: {
        email: '',
        ticket: '',
      },
    };
  },
  methods: {
    reset() {
      this.isLoading = true;
      this.$api.forgot({ ...this.params }).then(() => {
        this.$notification.success({ message: 'Успех', description: 'Ссылка для сброса пароля отправлена вам на почту' });
        this.params.email = '';
        this.$router.push('/auth');
      }).finally(() => {
        this.isLoading = false;
      });
    },
  },
  created() {
    const { hash } = window.location;
    if (/^#reset_ticket=/.test(hash)) {
      this.params.ticket = decodeURIComponent(hash.replace('#reset_ticket=', ''));
      this.isLoading = true;
      this.$api.forgot({ ...this.params }).then(() => {
        this.$notification.success({ message: 'Успех', description: 'Пароль успешно сброшен' });
        this.$router.push('/auth');
      }).finally(() => {
        this.isLoading = false;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}
</style>
